<template>
  <v-toolbar v-if="shouldShowToolbar" floating class="px-4 headerToolbar">
    <div v-if="!disableFavorite && routeId" class="mr-3">
      <v-icon v-if="isFavorite" color="primary" @click="toggleFavorite">
        mdi-star
      </v-icon>
      <v-icon v-else @click="toggleFavorite">mdi-star-outline</v-icon>
    </div>

    <v-icon v-if="routeIcon">{{ routeIcon }}</v-icon>
    {{ routeNamePath }}

    <v-spacer />
    <div ref="headerCenter"></div>

    <v-spacer />
    <div ref="headerRight"></div>
  </v-toolbar>
</template>

<script setup>
import { ref, computed, toRefs, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useRootStore } from '../stores/root';
import { storeToRefs } from 'pinia';
import { navItems } from '../helpers/navItems';

const props = defineProps({
  disableFavorite: {
    type: Boolean,
    default: false,
  },
});
const { disableFavorite } = toRefs(props);

const store = useRootStore();
const { favoritePages, language } = storeToRefs(store);
onMounted(store.getFavoritePages);

function addBaseToRoute(path) {
  // strip the last / from the base url, so /admin/ => /admin, /admin => /admin, / => /
  const stripped = import.meta.env.BASE_URL.replace(/\/$/, '');
  return import.meta.env.BASE_URL === '/' ? path : `${stripped}${path}`;
}

function findPathNames(menu, targetPath) {
  let result = '';
  function search(items) {
    for (const item of items) {
      if (item.path === targetPath) {
        result = item;
        return true;
      }
      
      if (item.children) {
        if (search(item.children)) {
          return true;
        }
      }
    }
    return false;
  }
  
  search(menu);
  return result;
}


const route = useRoute();
const routeNamePath = computed(() => {
  const routeBase = addBaseToRoute(route.path);
  const currentMenuItem = findPathNames(navItems.value, routeBase);
  return currentMenuItem[`name${language.value.toUpperCase()}`] || currentMenuItem.name;
});

const routeIcon = computed(() => route?.icon);
const routeId = computed(() => route?.meta?.id);

const shouldShowToolbar = computed(() => {
  const hiddenRoutes = ['/commshub/home'];
  const isHiddenRoute = hiddenRoutes.includes(route.path);
  const hasHidePageHeaderMeta = route.meta?.hidePageHeader;

  return !isHiddenRoute && !hasHidePageHeaderMeta;
});

const isFavorite = computed(() => {
  return favoritePages.value?.some((f) => f === routeId.value);
});
function toggleFavorite() {
  let favorites = favoritePages.value;
  if (isFavorite.value) {
    favorites = favorites.filter((f) => f !== routeId.value);
  } else {
    favorites.push(routeId.value);
  }
  store.setFavoritePages(favorites);
  // isFavorite.value = !isFavorite.value;
}

const headerRight = ref();
const headerCenter = ref();
defineExpose({ headerRight, headerCenter });
</script>

<style scoped>
.headerToolbar {
  width: 100%;
}
</style>
